module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"manage_shipping":"Manage Shipping","ship_parcel":"Ship parcel"},"id":{"manage_shipping":"Kelola pengiriman","ship_parcel":"Kirim paket"}}')
  delete Component.options._Ctor
}
